module.exports = __webpack_public_path__ + "img/20190829151418535.891b0259.jpg";